import React from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';

export const invoiceFormatter = (cell, row) => {
  const invoiceNumber = row?.number;
  const [firstInvoiceNumber] = Array.isArray(invoiceNumber) ? invoiceNumber : [invoiceNumber];

  return (
    <MuiLink variant="subtitle1" component={Link} to={`/invoices/${row.id}`}>
      {firstInvoiceNumber && firstInvoiceNumber !== '' ? firstInvoiceNumber : 'concept'}
    </MuiLink>
  );
};

export default invoiceFormatter;
